import React, { Component} from 'react'
import { connect } from 'react-redux'
import { isFetching } from 'utils/redux/fetching'
import { fetchMostWanted } from 'redux/actions/mostWanted'
import { fetchCurrencies } from 'redux/actions/currencies'
import { modes } from 'utils/redux/config/modes'
import FeaturedCurrencyCard from 'components/FeaturedCurrencyCard'
import Loader from 'components/Loader'
import Heading from 'components/Heading'
import Slider from 'components/carousel/Carousel'
import moment from 'moment'

class FeaturedCurrencyCardsContainer extends Component {
	componentWillMount() {
		const { dispatch } = this.props
		dispatch(fetchCurrencies())
		dispatch(fetchMostWanted())
	}
	render () {
		if(this.props.isFetching) return <Loader />

		const { mostWanted, selectedMode } = this.props
		const modeSettings = modes[selectedMode]
		const actualDateTime = mostWanted[0].date
		return <div>
			<Heading
				text={`${modeSettings.namePl} за ${moment(actualDateTime).format('DD.MM.YYYY')}`}
				classes={`u-heading-line u-heading-line-${modeSettings.oppositeColor}`} />
			<Slider
				className='c-featured-card__container c-featured-card__container--monetary'
				options={{
					slidesToShow: 4,
					autoplay: true,
					arrows: false,
					responsive: [
						{
							breakpoint: 980,
							settings: {
								slidesToShow: 3,
							}
						},
						{
							breakpoint: 820,
							settings: {
								slidesToShow: 2,
							}
						},
						{
							breakpoint: 550,
							settings: {
								slidesToShow: 1,
							}
						}
					]
				}}>
				{ mostWanted.map(currency => <FeaturedCurrencyCard key={currency.id} currency={currency} mode={selectedMode}/>)}
			</Slider>
		</div>
	}
}

const mapStateToProps = state => {

	const { currencies, mostWanted } = state

	if (isFetching([currencies, mostWanted])) return { isFetching: true }

	return {
		mostWanted: mostWanted.data
	}
}


export default connect(mapStateToProps)(FeaturedCurrencyCardsContainer)
